<template>
    <section
        class="testimonial section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="testimonial-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content invert-color" />
                <div
                    class="tiles-wrap illustration-section-06"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-up">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-01.png')"
                                        alt="Testimonial image 01"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0">
                                    — I've been a professional options trader for 15 years. I decided to trial Smart Algo and since then it has always had a place in my trading arsenal. It definitely reduces a lot of the noise and makes me feel more confident in my trades.
                                </p>
                            </div>
                            <div class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                    Chris H.
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    T3 Trading Group, LLC
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="200">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-02.png')"
                                        alt="Testimonial image 02"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0">
                                    — I decided to reconsider my trading strategy after making a bad trade on Dogecoin. I have been using the premium indicator on multiple timeframes and it is by far my favorite indicator now.
                                </p>
                            </div>
                            <div
                                class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                    James S.
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    ElixirShots.com
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="400">
                        <div class="tiles-item-inner has-shadow">
                            <div class="testimonial-item-header">
                                <div class="testimonial-item-image">
                                    <c-image
                                        :src="require('@/assets/images/testimonial-image-03.png')"
                                        alt="Testimonial image 03"
                                        :width="56"
                                        :height="56" />
                                </div>
                            </div>
                            <div class="testimonial-item-content">
                                <p class="text-sm mb-0">
                                    — A friend turned me onto this and I must say that Smart Algo is the real deal. I had no idea how to use this but I joined the Discord and the staff was super helpful and showed me how to add the indicator to the chart.
                                </p>
                            </div>
                            <div
                                class="testimonial-item-footer h6 mt-32 mb-0 pt-24 has-top-divider">
                                <span class="testimonial-item-name">
                                    Jorge M.
                                </span>
                                <span class="text-color-low"> - </span>
                                <span class="testimonial-item-link text-xs">
                                    Trader
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CTestimonial',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: 'Trusted by Professional and Novice Traders',
        paragraph: ''
      }
    }
  }
}
</script>